module.exports = __webpack_public_path__ + "static/media/step-info.941ace88.png";